import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Common {
  allowDigitsOnly(event: KeyboardEvent): void {
    const key = event.key;
    const allowed =
      /[0-9]/.test(key) ||
      key === 'Backspace' || key === 'ArrowLeft' || key === 'ArrowRight' ||
      key === 'Tab' || key === 'Delete';
    if (!allowed) event.preventDefault();
  }

  allowDigitsWithDecimal(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;

    const numeric = /[0-9]/.test(key);
    const controlKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(key);
    const dot = key === '.' && !input.value.includes('.');

    if (!(numeric || controlKeys || dot)) {
      event.preventDefault();
    }
  }

  
  getIssueType(flag: string): string {
    if (flag && ['created', 'new'].includes(flag.toLowerCase())) {
      return 'Log';
    } else if (flag && ['updated', 'update'].includes(flag.toLowerCase())) {
      return 'Update';
    } else {
      return flag || 'Log';
    }
  }

  getNavigateByRole(roleName: string): string {
    let role = roleName ? roleName.toLowerCase() : '';
    if (['flms', 'flm'].includes(role)) {
      return '/chat';
    } else if (['supervisors', 'supervisor'].includes(role)) {
      return '/review';
    } else if (['riskofficers', 'riskofficer'].includes(role)) {
      return '/review';
    } else {
      return '/unauthorized';
    }
  }
}
